export const user = {
  id: 1,
  avatar: 'image.png',
  first_name: 'GIT',
  is_administrator: false,
  is_client: true,
  is_network_partner: false,
  last_name: 'Client',
  identity: 'test'
};
export const userArray = [{
  id: 1,
  avatar: 'image.png',
  first_name: 'GIT',
  is_administrator: false,
  is_client: true,
  is_network_partner: false,
  last_name: 'Client',
  identity: 'test'
}, {
  id: 2,
  avatar: 'image.png',
  first_name: 'GIT',
  is_administrator: false,
  is_client: true,
  is_network_partner: false,
  last_name: 'Client',
  identity: 'test'
}];
export const userList = {
  id: 1,
  url: 'http://localhost:8000/api/users/1/',
  first_name: 'Test',
  last_name: 'Admin',
  email: 'dev.admin@gtintel.io',
  phone: '',
  alter_phone: null,
  authy_id: '',
  company: 'Ground Truth Intelligence',
  street_address: '27 Dev Test Rd',
  apartment: '',
  biography: null,
  tags: [],
  tag_groups: [],
  avatar: null,
  is_client: false,
  is_administrator: true,
  is_network_partner: false,
  accept_batch: false,
  timezone: 'America/New_York',
  dual_account: null,
  is_active: true,
  full_name: 'Test Admin',
  edit_role: true,
  is_auto_tag: true,
  is_deleted: false,
  notes: null,
  team: null,
  role: 1
};
export const networkPartner = {
  id: 2,
  url: 'http://localhost:8000/api/users/2/',
  first_name: 'Test',
  last_name: 'Partner',
  email: 'dev.partner@gtintel.io',
  phone: '',
  alter_phone: null,
  authy_id: '',
  company: 'Duly Diligent',
  street_address: '123 Fake Street',
  apartment: '',
  biography: null,
  tags: [],
  tag_groups: [],
  avatar: null,
  is_client: false,
  is_administrator: false,
  is_network_partner: true,
  accept_batch: false,
  timezone: 'America/New_York',
  dual_account: null,
  is_active: true,
  full_name: 'Test Partner',
  edit_role: true,
  is_auto_tag: true,
  is_deleted: false,
  notes: null,
  team: null,
  role: 1
};